export default __webpack_public_path__ + "static/media/1996.6418d047.png";